(() => {
  const node = document.querySelector('[data-sb-event-config]');
  if (!node || !window.SBEventCart) return;
  let config = JSON.parse(node.textContent);
  const C = window.SBEventCart;
  let checking = false;
  function url(kind, params = {}) {
    const target = new URL(kind === 'events' ? config.eventUrl : config.attendeeUrl, location.origin);
    for (const [key, value] of Object.entries(params)) if (value !== undefined && value !== null && value !== '') target.searchParams.set(key, String(value));
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) target.searchParams.set('preview_theme_id', preview);
    return target.pathname + target.search;
  }
  async function refresh() {
    const target = new URL(config.root, location.origin);
    target.searchParams.set('section_id', 'sb-event-data');
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) target.searchParams.set('preview_theme_id', preview);
    const response = await fetch(target, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new C.FlowError('network');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const freshNode = html.querySelector('[data-sb-event-config]');
    if (!freshNode) throw new C.FlowError('network');
    const fresh = JSON.parse(freshNode.textContent);
    if (fresh.eventId !== config.eventId || fresh.productId !== config.productId) throw new C.FlowError('conflict');
    config = fresh;
    return config;
  }
  function start(variant, quantity = 1, group = '') {
    const q = Number(quantity);
    if (!Number.isInteger(q) || q < 1 || q > config.maxQuantity) throw new C.FlowError('quantity');
    location.assign(url('attendees', { variant, quantity: q, group }));
  }
  function showError(message) {
    let error = document.querySelector('[data-event-checkout-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.eventCheckoutError = '';
      error.setAttribute('role', 'alert');
      error.tabIndex = -1;
      error.style.cssText = 'padding:16px;background:#f6f6f6;color:#000;border-left:2px solid #000';
      (document.querySelector('#cart-errors, .cart-drawer__footer, main') || document.body).append(error);
    }
    error.textContent = message;
    error.focus();
  }
  async function checkout() {
    if (checking) return;
    checking = true;
    document.querySelectorAll('[data-event-checkout]').forEach(el => el.setAttribute('aria-busy', 'true'));
    try {
      const fresh = await refresh();
      const cart = await new C.Client(fresh.root).read();
      const invalid = C.invalidGroup(cart, fresh);
      if (invalid) {
        location.assign(url('attendees', { variant: invalid.variant_id, group: invalid.properties?.[C.P.group], legacy: invalid.properties?.[C.P.group] ? '' : invalid.key }));
      } else {
        C.checkCart(cart, fresh);
        location.assign(fresh.root + 'checkout');
      }
    } catch (error) { showError(config.messages[error.code] || config.messages.network); }
    finally { checking = false; document.querySelectorAll('[data-event-checkout]').forEach(el => el.removeAttribute('aria-busy')); }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.matches('[data-attendee-form]')) return;
    if (form.querySelector('[name="form_type"][value="localization"]') && document.querySelector('[data-event-attendees], sb-events')) {
      // The custom footer submits directly, without Dawn's localization element.
      const current = new URL(location.href);
      const safe = new URLSearchParams();
      for (const key of ['view', 'group', 'variant', 'quantity', 'preview_theme_id']) if (current.searchParams.has(key)) safe.set(key, current.searchParams.get(key));
      let back = form.querySelector('[name="return_to"]');
      if (!back) { back = document.createElement('input'); back.type = 'hidden'; back.name = 'return_to'; form.append(back); }
      back.value = current.pathname + (safe.size ? '?' + safe : '');
    }
    const variant = form.querySelector('[name="id"]')?.value;
    if (config.variants.some(v => String(v.id) === String(variant)) && /\/cart\/add\/?$/.test(new URL(form.action, location.href).pathname)) {
      event.preventDefault(); event.stopImmediatePropagation();
      try { start(variant, new FormData(form).get('quantity') || 1, new URL(location.href).searchParams.get('group') || ''); }
      catch (error) { showError(config.messages.quantity_error); }
    } else if (event.submitter?.name === 'checkout' || form.matches('[data-event-checkout-form]')) {
      event.preventDefault(); event.stopImmediatePropagation(); checkout();
    }
  }, true);
  document.addEventListener('click', event => {
    const checkoutLink = event.target.closest('a[href]');
    if (checkoutLink && /\/checkout\/?$/.test(new URL(checkoutLink.href).pathname)) {
      event.preventDefault(); event.stopImmediatePropagation(); checkout(); return;
    }
    const action = event.target.closest('[data-event-purchase]');
    if (!action) return;
    event.preventDefault();
    const product = action.closest('product-info, .product');
    const variant = product?.querySelector('[name="id"]')?.value || action.dataset.variant;
    const quantity = product?.querySelector('[name="quantity"]')?.value || 1;
    try { start(variant, quantity); } catch (error) { showError(config.messages.quantity_error); }
  });
  function activate() { document.querySelectorAll('[data-event-checkout]').forEach(button => { if (button.dataset.eventCheckout === 'enabled' && button.disabled) button.disabled = false; }); }
  activate();
  new MutationObserver(activate).observe(document.body, { childList: true, subtree: true });
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, activate);
  window.SBEventFlow = { get config() { return config; }, url, refresh, start, checkout };
})();
